module.exports = __webpack_public_path__ + "img/yellow-blue-mob.d026d27f.png";